import { css } from 'styled-components';

export default css`
  [data-testid='unloadingMethod-form-field'] {
    padding-bottom: 0;
  }
`;
